import React, { useState } from 'react';
import Icon from '../Icon';
import Tooltip from '../Tooltip';

function SingleCollapse(props) {
  const { defaultActive, active, onClick = () => {} } = props;
  const [expand, setExpand] = useState(defaultActive === true);
  function handleChange() {
    if (active !== undefined) {
      return;
    }
    setExpand(!expand);
    onClick(expand);
  }
  return (
    <div className="hfish-singlecollapse">
      <div className="hfish-singlecollapse-header" onClick={handleChange}>
        <span>{props.header}</span>
        <Tooltip content={expand ? '收起' : '展开'}>
          <Icon
            className={`hfish-singlecollapse-icon ${
              expand ? 'hfish-singlecollapse-icon-up' : ''
            }`}
            type="down"
          />
        </Tooltip>
      </div>
      <div
        className={`hfish-singlecollapse-content ${
          expand ? '' : 'hfish-singlecollapse-content-hide'
        }`}
      >
        {props.children}
      </div>
    </div>
  );
}

export default SingleCollapse;
